import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { PatientMassLoadService } from '../services/PatientMassLoad.service';

export const useDownloadMassPatientLoadTemplate = () => {
    const { t } = useTranslation();

    const downloadTemplate = useCallback(async () => {
        try {
            const patientMassLoadService = new PatientMassLoadService();

            await patientMassLoadService.downloadTemplateLoadPatients();
        } catch (error) {
            //Mostramos error genérico en la notificación
            toast.error(t('error.download_mass_patient_load_template'));
        }
    }, [t]);

    return downloadTemplate;
};
